/**
 * The descriptor publishes Title Case labels because they head columns and badges. In a
 * sentence — "Plan 3 games for dev?" — they read lower-case. One rule, here.
 */
export type TypeLabel = { singular: string; plural: string };

export const pluralise = (label: TypeLabel, n: number): string => (n === 1 ? label.singular : label.plural);

export const inProse = (label: TypeLabel, n: number): string => `${n} ${pluralise(label, n).toLowerCase()}`;

/** `countWord(3, 'record')` → `"3 records"`; `countWord(1, 'record')` → `"1 record"`. A noun whose plural is not a bare `+'s'` gives its own. */
export const countWord = (n: number, one: string, many: string = `${one}s`): string => `${n} ${n === 1 ? one : many}`;

const LIST_FORMAT = new Intl.ListFormat('en-GB', { type: 'conjunction' });

/** "A", "A and B", "A, B and C" — the one list phrase, for adopt's and afterSave's confirmations. */
export const listOf = (items: readonly string[]): string => LIST_FORMAT.format(items);
